import { render } from "./ComplexStatisticsCard.vue?vue&type=template&id=c6dcdd98"
import script from "./ComplexStatisticsCard.vue?vue&type=script&lang=js"
export * from "./ComplexStatisticsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__